export default class TabsManager {

    constructor(documentSelector) {
        this.documentSelector = documentSelector;
    }

    loadTabs(dataEntity, allTabsContent)
    {
        this.allTabs = this.documentSelector.querySelectorAll("["+dataEntity+"]");
        allTabsContent.forEach((element, key) => {
            if (key == 0) {
                element.style.display = 'block';
            } else {
                element.style.display = 'none';
            }
        });
        this.eventDelegation(dataEntity, allTabsContent);
    }

    eventDelegation(dataEntity, allTabsContent)
    {
        let tabsContent = this.documentSelector.querySelector('.tab-container');
        let currentTarget = '';
        this.allTabs.forEach((element, key) => {
            if (key == 0) {
                element.classList.add('active');
            }

            element.addEventListener('click', (event) => {
                currentTarget = event.currentTarget;
                if (currentTarget.classList.contains('active')) {
                    return;
                }
                this.documentSelector.querySelector("["+dataEntity+"].active").classList.remove('active');
                currentTarget.classList.add('active');
                tabsContent.classList.add('fade-out');
            });
        });

        tabsContent.addEventListener('transitionend', (event) => {
            if (!currentTarget) {
                return;
            }
            tabsContent.classList.remove('fade-out');
            let activeTabContent = currentTarget.getAttribute(dataEntity);
            allTabsContent.forEach((element) => {
                if (element.getAttribute(dataEntity) === activeTabContent) {
                    element.style.display = 'block';
                } else {
                    element.style.display = 'none';
                }
            });
        });
    }
}
